export function isValidUtcOffset(offset: string): boolean {
  const match = /^([+-])(\d{2}):(\d{2})$/.exec(offset)
  if (!match) return false
  const [, sign, hourText, minuteText] = match
  const hours = Number(hourText)
  const minutes = Number(minuteText)
  if (![0, 15, 30, 45].includes(minutes)) return false
  if (sign === '-') return hours < 12 || (hours === 12 && minutes === 0)
  return hours < 14 || (hours === 14 && minutes === 0)
}
